import { c as _c } from "react/compiler-runtime";
import cx from 'classnames';
import { styled } from '@classify/react-core-components/styles';
import { isCurrentPath } from '@openclassrooms/routing';
import MainHeaderNavigationLink from './MainHeaderNavigationLink';
const Root = styled('div')(({
  theme: {
    breakpoints,
    spacing,
    palette
  }
}) => ({
  padding: spacing(1.5),
  [breakpoints.down('lg')]: {
    padding: spacing(1)
  },
  '& .NavigationLinkWrapper__active': {
    borderBottom: `3px solid ${palette.primary.main}`
  },
  '& .NavigationLinkWrapper__navLink': {
    whiteSpace: 'nowrap',
    padding: `${spacing(1)} 0`,
    textDecoration: 'none',
    fontSize: 16
  }
}));
const MainHeaderNavigationLinkWrapper = t0 => {
  const $ = _c(20);
  let otherProps;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      path: t1,
      shouldMatchPathname: t2,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
    $[3] = t2;
  } else {
    otherProps = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const path = t1 === undefined ? "" : t1;
  const shouldMatchPathname = t2 === undefined ? false : t2;
  let T0;
  let T1;
  let t3;
  let t4;
  let t5;
  if ($[4] !== otherProps || $[5] !== path || $[6] !== shouldMatchPathname) {
    const doesLocationMatch = isCurrentPath(path, shouldMatchPathname);
    T1 = Root;
    T0 = MainHeaderNavigationLink;
    t3 = otherProps;
    t4 = path;
    t5 = cx("NavigationLinkWrapper__navLink", {
      NavigationLinkWrapper__active: doesLocationMatch
    });
    $[4] = otherProps;
    $[5] = path;
    $[6] = shouldMatchPathname;
    $[7] = T0;
    $[8] = T1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    T0 = $[7];
    T1 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
  }
  let t6;
  if ($[12] !== T0 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <T0 {...t3} path={t4} className={t5} />;
    $[12] = T0;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== T1 || $[18] !== t6) {
    t7 = <T1>{t6}</T1>;
    $[17] = T1;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export default MainHeaderNavigationLinkWrapper;